import React from "react";
import { FadedSectionBody, SectionCallout } from "../../../SectionCallout";
import { RouteHelpers } from "../../../../root/routes";
import { stripTags } from "../../../../util/text";
import { SettingRow } from "./SettingRow";

interface PrivacyCenterOptOutNoticeEditorRowProps {
  label: string;
  notice: string;
}

export function PrivacyCenterOptOutNoticeEditorRow(props: PrivacyCenterOptOutNoticeEditorRowProps) {
  const helpText = "Edit the introduction text for your opt-out request submission page";

  return (
    <SettingRow title={props.label} helpText={helpText}>
      <div className="w-445">
        <SectionCallout
          title="Introduction"
          variant="white"
          actions={<a href={RouteHelpers.privacyCenter.editPrivacyIntro("opt-out")}>Edit</a>}
        >
          <FadedSectionBody body={stripTags(props.notice)} />
        </SectionCallout>
      </div>
    </SettingRow>
  );
}
